import React, { useContext, useEffect, useState } from 'react';
import { ProfileHeaderWrapper } from "./style";
import editIcon from "../../../images/edit.svg";
import { useNavigate, Link } from "react-router-dom";
import ContextDashboard from '../../../Context/ContextDashboard';
import { getDashboardData } from '../../../Utils/api';
import { getStorage, isEmpty } from '../../../Utils/common';
import { User, CreditCard, Mail } from "lucide-react";
function ProfileHeader({ children }) {
  const { message, setMessage, setProfileData, outdata, profileData, setSetps, getProfileDaital } = useContext(ContextDashboard);
  const [dashboard, setDashboard] = useState([]);
  const navigate = useNavigate();

  // Handle click for repayment redirection
  const handleClick = () => {
    navigate('/my-dashboard/repayment'); // Replace with your desired URL
  };

  // Fetch dashboard data on component mount
  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setDashboard(dashboardData);
      }
    });
  }, []);

  // Redirect to upload picture page
  const redirect = (link) => {
    navigate("/my-dashboard/upload-picture");
  };

  // Check if active_loan_details has valid data
  const hasActiveLoanDetails = dashboard?.Data?.active_loan_details &&
    (dashboard?.Data?.active_loan_details?.total_due > 0 ||
      Object.keys(dashboard?.Data?.active_loan_details).length > 0);

  return (
    <ProfileHeaderWrapper>
      <div className="main flex flex-col sm:flex-row justify-start">
        <div className="imgBox border p-1 border-gray-200 shadow-md">
          <img src={dashboard?.Data?.profile_pic} alt="" />
          {/* <div className="editIcon center" onClick={redirect}>
          <img src={editIcon} alt="" />
        </div> */}
        </div>





        <div className="flex-1 mt-4 lg:ml-8">

          {/* Outstanding Amount */}
          {hasActiveLoanDetails && (
            <div className="mb-5 rounded-xl border border-orange-200 bg-orange-50 p-4">

              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

                <div>
                  <p className="text-sm text-gray-600 font-medium">
                    Outstanding Amount
                  </p>

                  <h2 className="mt-1 text-xl sm:text-2xl font-bold text-[#173A7A]">
                    ₹{dashboard?.Data?.active_loan_details?.total_due || "0"}
                  </h2>
                </div>

                <button
                  onClick={handleClick}
                  className="w-full sm:w-auto rounded-lg bg-[#173A7A] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#102f62] transition"
                >
                  Pay Now
                </button>

              </div>

            </div>
          )}

          {/* Profile Details */}
          <div className="  ">

            {/* Name */}
            <div className="flex items-center gap-3 p-4  border-gray-200">

              <div className="flex h-10 w-10 sm:h-12 sm:w-12 shrink-0 items-center justify-center rounded-full bg-green-100">
                <User className="h-5 w-5 sm:h-6 sm:w-6 text-green-600" />
              </div>

              <div className="flex-1 flex flex-col sm:flex-row sm:items-center">

                <span className="w-full sm:w-28 text-sm font-medium text-gray-600">
                  Name
                </span>

                <span className="hidden sm:block mx-3 text-gray-400">:</span>

                <span className="text-sm sm:text-base font-semibold text-[#173A7A] break-words">
                  {dashboard?.Data?.full_name || "NA"}
                </span>

              </div>

            </div>

            {/* PAN */}
            <div className="flex items-center gap-3 p-4 border-gray-200">

              <div className="flex h-10 w-10 sm:h-12 sm:w-12 shrink-0 items-center justify-center rounded-full bg-blue-100">
                <CreditCard className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600" />
              </div>

              <div className="flex-1 flex flex-col sm:flex-row sm:items-center">

                <span className="w-full sm:w-28 text-sm font-medium text-gray-600">
                  PAN Card
                </span>

                <span className="hidden sm:block mx-3 text-gray-400">:</span>

                <span className="text-sm sm:text-base font-semibold text-[#173A7A]">
                  {dashboard?.Data?.profile_details?.pancard || "NA"}
                </span>

              </div>

            </div>

            {/* Email */}
            <div className="flex items-center gap-3 p-4">

              <div className="flex h-10 w-10 sm:h-12 sm:w-12 shrink-0 items-center justify-center rounded-full bg-purple-100">
                <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-purple-600" />
              </div>

              <div className="flex-1 flex flex-col sm:flex-row sm:items-center">

                <span className="w-full sm:w-28 text-sm font-medium text-gray-600">
                  Email
                </span>

                <span className="hidden sm:block mx-3 text-gray-400">:</span>

                <span className="text-sm sm:text-base font-semibold text-[#173A7A] break-all">
                  {dashboard?.Data?.profile_details?.personal_email?.trim()
                    ? dashboard?.Data?.profile_details?.personal_email.toLowerCase()
                    : "NA"}
                </span>

              </div>

            </div>

          </div>

        </div>
      </div>

      <div className="flex bottom">
        <p>
          Don't let uncertainty hold you back. It's time to explore the
          possibilities.
        </p>
        {children}
      </div>



    </ProfileHeaderWrapper>
  );
}

export default ProfileHeader;